import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-3 justify-center mb-3">
            <div className="w-2.5 h-2.5 rounded-full bg-accent-500 animate-pulse"></div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              动态快讯
            </h2>
          </div>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            最新影视内容更新实时速递
          </p>
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[11px] md:left-[13px] top-2 bottom-2 w-0.5 bg-background-300"></div>
            <div className="space-y-6 md:space-y-7">
              {updatesData.map((item, idx) => (
                <div key={idx} className="relative animate-fade-in-up" style={{ animationDelay: `${idx * 80}ms` }}>
                  <div className="absolute -left-[31px] md:-left-[35px] top-1.5 w-3.5 h-3.5 rounded-full bg-accent-500 border-[3px] border-background-100 z-10"></div>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-3">
                    <span className="text-xs text-foreground-400 font-medium whitespace-nowrap bg-background-200/70 px-2.5 py-0.5 rounded-full inline-block w-fit">
                      {item.time}
                    </span>
                    <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-center mt-8">
            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-background-200/70 text-xs text-foreground-500">
              <i className="ri-refresh-line"></i>
              实时更新中 · 更多精彩即将上线
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}